<template>
    <Modal
        :submit-text="submitText"
        @cancel="close(false)"
        @submit="close(true)"
    >
        <template #content>
            <div class="text-2xl font-medium mb-5">
                <i18next :translation="title">
                    <template #badge>
                        <BadgeCredits
                            :value="cost"
                            :badge-size="7"
                            :with-hover-effect="false"
                        ></BadgeCredits>
                    </template>
                </i18next>
            </div>
            <div>{{ modalText }}</div>
        </template>
    </Modal>
</template>

<script>
import Modal from '@components/Modal';
import ModalMixin from '@mixins/modalMixin';
import BadgeCredits from '@components/BadgeCredits/BadgeCredits.vue';
import { defineComponent } from 'vue';
import { useTranslation } from 'i18next-vue';

/**
 * This modal shows the amount they are about to spend and requires them to confirm it. I.e.: used in the subscription shop
 */
export default defineComponent({
    name: 'ModalConfirmSpendVirtualCurrency',
    components: {
        BadgeCredits,
        Modal,
    },
    extends: ModalMixin,
    props: {
        /**
         * credits the user is about to spend
         */
        cost: {
            type: Number,
            required: true,
        },
        /**
         * Text for the submit button
         */
        submitText: {
            type: String,
            required: true,
        },
        /**
         * Text for the content of the modal
         */
        modalText: {
            type: String,
            required: true,
        },
        /**
         * Text for the title of the modal. Needs to contain a {{badge}} key
         */
        title: {
            type: String,
            required: true,
        },
    },
    setup() {
        const { t } = useTranslation('subscription');
        return { t };
    },
});
</script>
